import { cloneVNode, Comment, Fragment, Text } from "vue";

function normalizeNode(node, slotName, bucket) {
    if (!node) {
        return;
    }

    if (Array.isArray(node)) {
        node.forEach((child) => normalizeNode(child, slotName, bucket));
        return;
    }

    if (node.type === Comment) {
        return;
    }

    if (node.type === Text) {
        if (String(node.children || "").trim() !== "") {
            bucket.default.push(node);
        }

        return;
    }

    if (node.type === Fragment && Array.isArray(node.children)) {
        node.children.forEach((child) => normalizeNode(child, slotName, bucket));
        return;
    }

    const currentSlot = node.props?.slot;
    const normalizedNode = currentSlot ? cloneVNode(node, { slot: undefined }) : node;

    if (currentSlot && Object.prototype.hasOwnProperty.call(bucket, currentSlot)) {
        bucket[currentSlot].push(normalizedNode);
        return;
    }

    bucket.default.push(normalizedNode);
}

export function collectLegacyModalSlots(slots) {
    const bucket = {
        body: [],
        default: [],
        footer: [],
        header: [],
    };

    const nodes = typeof slots?.default === "function" ? slots.default() : [];

    nodes.forEach((node) => normalizeNode(node, null, bucket));

    return bucket;
}

export const LegacySlotRenderer = {
    name: "LegacySlotRenderer",
    props: {
        nodes: {
            type: Array,
            default: () => [],
        },
    },
    render() {
        return this.nodes;
    },
};
